import { useAuth } from 'lib/auth';
import { useGet } from 'lib/swr-crud';
import {
  getUserReferralCode,
  getUserReferralCodeUrl,
  putUpdateReferralCode,
} from './api';
import { APIErrorResponse } from 'lib/utils';
import { AxiosError } from 'axios';
import { CouponAPIResponse } from 'lib/coupons/interface';

export const useUserReferralCode = () => {
  const { session, loading } = useAuth();

  const shouldFetch = !loading && session;

  const userId = session?.user?.userId;

  const { data, error, isLoading, mutate } = useGet<
    CouponAPIResponse,
    AxiosError<APIErrorResponse>
  >(
    shouldFetch ? getUserReferralCodeUrl(userId!) : null,
    async () => {
      return await getUserReferralCode(userId!);
    },
  );

  const updateReferralCode = async ({
    oldReferralCode,
    newReferralCode,
  }) => {
    const updatedReferralCode = await putUpdateReferralCode({
      oldReferralCode,
      newReferralCode,
    });

    return mutate(updatedReferralCode);
  };

  const referralCode = data?.coupon_code || null;
  const lastUsedAt = data?.last_used_at || null;

  return {
    referralCode,
    lastUsedAt,
    updateReferralCode,
    error,
    isLoading,
    mutate,
  };
};
